export default {
  alias      : 'enlace_externo_documento',
  route      : '/app/tramite/enlace_externo_documento',
  hash       : false,
  store      : false,
  key        : 'id',
  name       : 'documento_id',
  selectable : false,
  default    : {
    id           : null,
    documento_id : null,
    created_at   : null,
    updated_at   : null,
  },
}
  